<script setup lang="ts">
import { ContextMenuItem, type ContextMenuItemProps } from 'reka-ui'
import { cn } from '@/lib/utils'

const props = defineProps<ContextMenuItemProps & { class?: string }>()
</script>

<template>
  <ContextMenuItem
    v-bind="props"
    :class="cn(
      'relative flex cursor-default select-none items-center rounded-sm px-2 py-1.5 text-sm outline-hidden transition-colors focus:bg-accent focus:text-accent-foreground data-disabled:pointer-events-none data-disabled:opacity-50',
      props.class,
    )"
  >
    <slot />
  </ContextMenuItem>
</template>
